// Veritabanı geçişi sürerken üstte bakım şeridi (durum 60 sn'de bir ve sekmeye dönüşte yenilenir)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Wrench } from 'lucide-react';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/public/maintenance-status`;

export const MaintenanceBanner = () => {
  const [active, setActive] = useState(false);
  useEffect(() => {
    const load = () => !document.hidden && axios.get(URL).then(r => setActive(!!r.data.active)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    document.addEventListener('visibilitychange', load);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', load); };
  }, []);
  if (!active) return null;
  return (
    <div className="mb-5 flex items-start gap-3 rounded-lg border border-sky-300 bg-sky-50 px-4 py-3 text-sm text-sky-900" data-testid="maintenance-banner">
      <Wrench className="h-5 w-5 shrink-0 text-sky-600" />
      <span><b>Sistem kısa bir bakımda.</b> Kayıtları görüntüleyebilirsiniz; ekleme, düzenleme, onay ve belge yükleme işlemleri birkaç dakika içinde yeniden açılacak.</span>
    </div>
  );
};
